import { TableCell } from "@mui/material";
import { ColContainer } from "./styles";

export type TMultipleCol = {
  top: string;
  bottom: string;
  key: string;
  lbl?: string;
};

export const MultipleCol: React.FC<TMultipleCol> = (col) => {
  return (
    <>
      <TableCell key={col.key}>
        <ColContainer>
          <span className="top">{col.top}</span>
          <span className="bottom">{col.bottom}</span>
        </ColContainer>
      </TableCell>
    </>
  );
};
